import styled from '@emotion/styled';
import { display, height } from 'styled-system';
import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';

const ImageWrapper = styled(Box)`
  height: 0;
  overflow: hidden;
  position: relative;
  padding-top: ${(props) => props.ratio};
  ${display};
  ${height};
`;

ImageWrapper.displayName = 'ImageWrapper';

const StyledImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;

  @supports (object-fit: cover) {
    height: 100%;
    object-fit: cover;
  }
`;

const PropertyImage = ({ src, alt, ...otherProps }) => (
  <ImageWrapper data-testid="property-image" {...otherProps}>
    <StyledImage src={src} alt={alt} />
  </ImageWrapper>
);

PropertyImage.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
  ratio: PropTypes.string,
};

PropertyImage.defaultProps = {
  src: undefined,
  alt: undefined,
  ratio: '50%',
};

export default PropertyImage;
